import React, { useEffect, useState, useRef } from "react"
import { getGCSFlightStats, getGCSFlights, getGCSFlightsAcresGraphStats, getGCSFlightsGraphStats, deleteFlightData } from "../../api"
import InteractiveGraph from "../Components/InteractiveGraph"
import FlightsFilter from "../Components/FlightsFilter/FlightsFilter"
import "../Flights/Flights.css"
import TableView from "../../ReusableComponents/TableView/TableView"
import { useHistory, useLocation } from "react-router-dom"
import { getFlightTime } from "../Flights/Flights"
import { BreadCrumbs } from "../../ReusableComponents/BreadCrumbs"
import { Popup, addUserAnalytic, updateOutTime } from "../../ReusableComponents/reusableFunctions"
import Cookies from "universal-cookie"
import LoaderComponent from "../../ReusableComponents/LoaderComponent"
import { useFirstRender } from "../../ReusableComponents/firstRender"
import { ActivityPopup } from "../../ReusableComponents/ActivityPopup"
import { GCS_FEATURES, getFeaturesPermissions } from "../../Teams"
import flightReplay from "../../replayVideo.svg";
import dateFormat from 'dateformat';
import FlightChart from "../Flights/FlightChart"
import Select from "react-dropdown-select"
import InMaintenanceIcon from '../../InMaintenanceIcon.svg';

const Acres = (props) => {
    const cookies = new Cookies()
    const history = useHistory();
    const location = useLocation();
    const { user } = props.location.state
    const [flights, setFlights] = useState([])
    const [flightAcresStats, setFlightAcresStats] = useState(null)
    const [flightsAcresGraphStats, setFlightsAcresGraphStats] = useState(null)
    const [tableState, setTableState] = useState({ pageNumber: 1, pageSize: 15 })
    const [filterState, setFilterState] = useState(null)
    const [flightsTableLoading, setFlightsTableLoading] = useState(true)
    const [cookieData, setCookieData] = useState()
    const [permissions, setPermissions] = useState()
    const [activityPopup, setActivityPopup] = useState(undefined)
    const [deleteData, setDeleteData] = useState(undefined)
    const [outId, setOutId] = useState("")
    const [selectedChartType, setSelectedChartType] = useState('sprayed_area')
    const [activeTeam, setActiveTeam] = useState('')

    const initialLoadComplete = useRef(false);
    const didMount = useRef(false);

    const getFlights = async () => {
        try {
            setFlightsTableLoading(true)
            const data = await getGCSFlights({ ...tableState, ...filterState })
            setFlights(data)
            setFlightsTableLoading(false)
        } catch (e) {
            setFlightsTableLoading(false)
            Popup.alert("ERROR", e?.message || e)
        }
    };

    const getAcresStats = async () => {
        try {
            setFlightAcresStats(null)
            const stats = await getGCSFlightStats(filterState)
            setFlightAcresStats(stats)
        } catch (e) {
            Popup.alert("ERROR", e?.message || e)
        }
    }

    const getFlightsAcresGraphStats = async () => {
        try {
            setFlightsAcresGraphStats(null)
            const stats = await getGCSFlightsAcresGraphStats(filterState)
            setFlightsAcresGraphStats(stats)
        } catch (e) {
            Popup.alert("ERROR", e?.message || e)
        }
    }

    useEffect(() => {
        if (!initialLoadComplete.current) return;
        if (filterState) {
            const page_data = cookies.get("page_data") || {};
            const newPageData = { ...page_data, acres: { ...page_data?.acres, tableState: tableState } };
            cookies.set("page_data", JSON.stringify(newPageData), { path: "/" });

            getFlightsAcresGraphStats();
            getAcresStats();
            getFlights();
        }
    }, [filterState]);

    useEffect(() => {
        if (!initialLoadComplete.current) return;
        if (tableState) {
            const page_data = cookies.get("page_data") || {};
            const newPageData = { ...page_data, acres: { ...page_data?.acres, tableState: tableState } };
            cookies.set("page_data", JSON.stringify(newPageData), { path: "/" });
            getFlights();
        }
    }, [tableState]);



    useEffect(() => {
        if (initialLoadComplete.current) return;

        const initialize = async () => {
            const page_data = cookies.get("page_data");
            const data = page_data?.acres || {};
            setTableState(prev => ({ ...prev, pageNumber: data?.tableState?.pageNumber || prev.pageNumber }))
            if (data.tableState) {
                setTableState(data.tableState);
            }
            setCookieData(data);
            initialLoadComplete.current = true;
            if (location.state?.filterState) {
                setFilterState(location.state.filterState);
            } else {
                const { tableState, ...persistedFilters } = data;
                if (Object.keys(persistedFilters).length > 0) {
                    setFilterState(persistedFilters);
                }
            }
            const [id, permissions] = await Promise.all([
                addUserAnalytic(props.location.pathname),
                getFeaturesPermissions([GCS_FEATURES.PLANS])
            ]);

            setOutId(id);
            setPermissions(permissions);
            // didMount.current = true;
        };

        initialize();
    }, []);

    useEffect(() => {
        if (location.state && location.state.filterState) {
            setFilterState(location.state.filterState);
        }
        didMount.current = true;
    }, []);

    useEffect(() => {
        if (!didMount.current) return;
        if (filterState && (!location.state || JSON.stringify(location.state.filterState) !== JSON.stringify(filterState))) {
            history.replace({ pathname: location.pathname, state: { ...props.location.state, filterState } });
        }
    }, [filterState]);

    const closeActivityPopup = () => {
        setActivityPopup(undefined)
    }

    const deleteFlight = async () => {
        try {
            setActivityPopup({
                open: true,
                msg: 'Deleting flight and related data please wait...',
                item: "WAIT",
                icon: "WAIT",
            })
            const data = await deleteFlightData(deleteData.id)
            setActivityPopup({
                open: true,
                msg: data.message,
                item: "COMPLETE",
                icon: "COMPLETE",
            })
            setDeleteData(undefined)
            getFlightsAcresGraphStats()
            getAcresStats()
            getFlights()
        }
        catch (e) {
            setDeleteData(undefined)
            closeActivityPopup()
            Popup.alert("ERROR", e?.message || e)
        }

    }

    useEffect(() => () => { updateOutTime(outId); }, [outId]);

    const getChartData = () => {
        if (!flightAcresStats) return { data: [], totalFlights: 0 };

        const statsToUse = selectedChartType === 'sprayed_area'
            ? flightAcresStats.areaRangeStats
            : flightAcresStats.acresByPilotStats;

        const validStats = statsToUse?.filter(
            (item) => item.area_range !== "Unknown"
        ) || [];

        const [lv1, lv2, lv3, lv4, lv5] = validStats.map(item => Number(item.flight_count));
        const [area1, area2, area3, area4, area5] = validStats.map(item => Number(item.total_area_covered));
        return {
            lv1: lv1 ?? 0,
            lv2: lv2 ?? 0,
            lv3: lv3 ?? 0,
            lv4: lv4 ?? 0,
            lv5: lv5 ?? 0,
            area1: area1 ?? 0,
            area2: area2 ?? 0,
            area3: area3 ?? 0,
            area4: area4 ?? 0,
            area5: area5 ?? 0,
        };
    };

    const chartData = getChartData();

    return (
        <div className="wrapper" style={{ fontFamily: 'Lato' }}>
            <div className="right-content-new">
                <div className="top-bar-new">
                    <div className="top-bar-text-new">
                        <BreadCrumbs
                            data={[{ displayName: "Home", pathname: "/", state: { user } }, { displayName: 'Acres' }]}
                        />
                    </div>
                </div>
                <div className="main-content-new flights-main-content">
                    <ActivityPopup
                        item={activityPopup?.item}
                        open={activityPopup?.open}
                        icon={activityPopup?.icon}
                        msg={activityPopup?.msg}
                        close={closeActivityPopup}
                        onClickOk={deleteFlight}
                    />
                    {cookieData ? (
                        <>
                            <FlightsFilter
                                stats={{
                                    "Flights": flightAcresStats?.total_flights || 0,
                                    "Flight Time": flightAcresStats?.total_flight_time ? getFlightTime(flightAcresStats.total_flight_time) : 0,
                                    "Pilots worked": flightAcresStats?.total_pilots || 0,
                                    "Utilize Drones": flightAcresStats?.total_drones_utilize || 0,
                                }}
                                statsSecondRow={{
                                    "Sprayed Area (Acr)": `${flightAcresStats?.total_acres_covered ? `${Math.round(Number(flightAcresStats.total_acres_covered) / 4046.85642)}` : 0}`,
                                    "Acres By Pilot": `${flightAcresStats?.acres_by_pilot ? flightAcresStats.acres_by_pilot : 0}`,
                                }}
                                isPilotEnable
                                cookiesData={tableState.pageNumber || 1}
                                selectedTab={filterState?.selectedTab || props.location.state.interval || cookieData?.selectedTab}
                                selectedDrone={filterState?.selectedDrones?.[0] || props.location.state.selectedDrone || cookieData?.selectedDrones?.[0]}
                                selectedPilot={filterState?.selectedPilots?.[0] || props.location.state.selectedPilot || cookieData?.selectedPilots?.[0]}
                                defaultFromDateTime={filterState?.fromDateTime || cookieData?.fromDateTime}
                                defaultToDateTime={filterState?.toDateTime || cookieData?.toDateTime}
                                filterState={{ ...tableState, ...filterState }}
                                onFilterDataChange={(data) => {
                                    if (data.refresh !== 1) setTableState(prev => ({ ...prev, pageNumber: 1 }));
                                    const { pageNumber, ...rest } = data;
                                    setFilterState(rest);
                                }}
                            />
                            <div style={{ width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "30px" }}>
                                <div style={{ width: "60%", height: "100%", alignItems: "center" }}>
                                    <InteractiveGraph
                                        showZoom
                                        data={flightsAcresGraphStats?.length > 1 ? flightsAcresGraphStats?.map(stat => ({
                                            ...stat,
                                            value: Number(stat.value) > 0 ? (Number(stat.value) / 4046.85642).toFixed(4) : Number(stat.value)
                                        })) : []}
                                        lineType={0}
                                        loading={!flightsAcresGraphStats}
                                        showDecimalValues
                                        fromDate={filterState?.fromDateTime}
                                        interval={filterState?.selectedTab?.toLowerCase()}
                                        style={{ height: '100%' }}
                                    />
                                </div>
                                <div style={{ width: "40%", height: "400px", margin: "28px 0px 0px 0px", padding: "20px", backgroundColor: "white", border: "1px solid #e9ecef", display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "flex-end" }}>
                                    <div style={{ width: "190px", height: "20px", margin: "5px 0px", display: "flex", alignItems: "flex-end", justifyContent: "flex-end", alignItems: "flex-end" }}>
                                        <Select
                                            placeholder="Select graph type"
                                            options={[
                                                { label: 'Sprayed Area (Acr)', value: 'sprayed_area' },
                                                { label: 'Acres By Pilot', value: 'acres_by_pilot' }]}
                                            values={[{
                                                label: selectedChartType === 'sprayed_area' ? 'Sprayed Area (Acr)' : 'Acres By Pilot',
                                                value: selectedChartType
                                            }]}
                                            className="custom_dropdown"
                                            style={{ borderRadius: "7px" }}
                                            onChange={(values) => {
                                                if (values.length > 0) {
                                                    setSelectedChartType(values[0].value);
                                                }
                                            }}
                                        />
                                    </div>
                                    {(flightsAcresGraphStats) ?
                                        <FlightChart lv1={chartData.lv1} lv2={chartData.lv2} lv3={chartData.lv3} lv4={chartData.lv4} lv5={chartData.lv5} area1={chartData.area1} area2={chartData.area2} area3={chartData.area3} area4={chartData.area4} area5={chartData.area5} chartType={selectedChartType} />
                                        : <LoaderComponent message="Loading, please wait..." />
                                    }
                                </div>
                            </div>
                            <div className="table-container">
                                <TableView
                                    pageNumber={tableState.pageNumber}
                                    onStateChange={setTableState}
                                    headingLeft={"Flights"}
                                    isLoading={flightsTableLoading}
                                    tableHeight={"calc(100% - 100px)"}
                                    onClickRow={(flight) => {
                                        delete flight.maintencance_icon
                                        delete flight.link_data;
                                        history.push('/aerogcsenterprise/remote_mission/flight_details', {
                                            user,
                                            flightId: flight.id,
                                            fromScreen: "Acres"
                                        });
                                    }}
                                    columns={[
                                        { Header: '', accessor: 'maintencance_icon', isSortable: false, isCenter: true, onHoverText: 'Drone is in maintenance' },
                                        { Header: "Project/Plan Name", accessor: "projectPlanName", width: '15%' },
                                        { Header: "Drone", accessor: "drone_name", width: '11%', isSortable: true },
                                        { Header: "Start/End Time", accessor: "flightDate", width: '20%' },
                                        { Header: "Total Time", accessor: "total_flight_time", width: '10%', isSortable: true },
                                        { Header: "Distance (M)", accessor: "distance_covered", width: '10%', isSortable: true },
                                        { Header: "Sprayed Area (Acr)", accessor: "area_covered", width: '12%', isSortable: true },
                                        { Header: "Acres By Pilot", accessor: "acres", width: '12%', isSortable: true },
                                        { Header: "Consumed Liquid (ml)", accessor: "consumed_liquid", width: '12%', isSortable: true },
                                        { Header: "Replay", accessor: "link_data", width: '5%', isIcon: true, isCenter: true }]}
                                    count={flightAcresStats?.total_flights}
                                    data={flights?.map(flight => ({
                                        ...flight,
                                        maintencance_icon: flight.is_drone_in_maintenance ? <img style={{ width: "20px", height: '20px' }} src={InMaintenanceIcon} /> : undefined,
                                        flightDate: `${dateFormat(flight.start_time, "dd/mm/yyyy hh:MM TT")} / ${dateFormat(flight.end_time, "hh:MM TT")}`,
                                        projectPlanName: `${flight.project_name}/${flight.plan_name}`,
                                        total_flight_time: getFlightTime(flight.total_flight_time),
                                        area_covered: (Number(flight.area_covered) / 4046.85642).toFixed(4),
                                        link_data: {
                                            img: flightReplay,
                                            onClick: (flight) => { props.history.push("/aerogcsenterprise/drone_control_center/fly_view", { flight: flight.id, user, replyData: 0 }) }
                                        }
                                    })) || []}
                                    activities={{
                                        disableDelete: !permissions?.[GCS_FEATURES.PLANS]?.DELETE,
                                        onClickDelete: (flight) => {
                                            setDeleteData(flight)
                                            setActivityPopup({
                                                open: true,
                                                msg: 'Are you sure you want to delete selected flight and related data. (ie. streaming video, images, flight logs) ?',
                                                item: "WARNING",
                                                icon: "WARNING",
                                            })
                                        }
                                    }}
                                    user={user}
                                />
                            </div>
                        </>
                    ) : (
                        <LoaderComponent />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Acres